import { combineReducers } from 'redux';
import app from './app/merged.reducer';
import user from './user/merged.reducer';
import provider from './provider/merged.reducer';
import recovery from './auth/merged.reducer';
import customers from './customers/merged.reducer';
import events from './events/merged.reducer';
import eventGroups from './eventGroups/merged.reducer';
import bookings from './bookings/merged.reducer';
import search from './search/merged.reducer';
import products from './products/merged.reducer';
import payments from './payments/merged.reducer';
import downloads from './downloads/merged.reducer';
import imports from './imports/imports.reducer';
import zoom from '~/store/zoom/merged.reducer';
import { externalPartiesReducers } from './integrations/merged.reducer';
import alerts from './alerts';

import { REQUEST_ACTIONS, STATIC_ACTIONS, STATUS } from '~/Constants/Actions.constants';
import { INeoAction } from './Actions.interface';

const appState = combineReducers({
  app,
  zoom,
  user,
  recovery,
  alerts,
  provider,
  products,
  customers,
  events,
  eventGroups,
  bookings,
  search,
  payments,
  downloads,
  imports,
  integrations: externalPartiesReducers,
});

const reducers = (state: any, action: INeoAction) => {
  const { name, status } = action;
  // if the user tried to log in and failed, clear redux (token expired);
  if (
    (name === REQUEST_ACTIONS.USER_ROLES && status === STATUS.UNAUTHORIZED) ||
    action.type === STATIC_ACTIONS.LOGOUT
  ) {
    // eslint-disable-next-line no-param-reassign
    state = undefined;
    // purge the data that is stored in the reducers through redux-persist
    localStorage.clear();
  }

  return appState(state, action);
};

export default reducers;
